import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

const VendorAdvanceForm = ({
  vendors,
  advanceForm,
  handleChange,
  handleSubmit,
  handleCancel,
  setVendors,
  setAdvanceForm,
  handleKeyDown,
}) => {
  const isEdit = !!advanceForm.id;

  const [vendorName, setVendorName] = useState("");
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [highlightedVendorIndex, setHighlightedVendorIndex] = useState(-1);
  const [showVendorList, setShowVendorList] = useState(false);
  useEffect(() => {
    if (advanceForm.vendor_id && vendors.length > 0) {
      const vendor = vendors.find((v) => v.id === advanceForm.vendor_id);
      if (vendor) {
        setVendorName(vendor.name);
      }
    }
  }, [advanceForm.vendor_id, vendors]);

  const handleVendorChange = (e) => {
    const input = e.target.value;
    setVendorName(input);

    const filtered = vendors.filter((v) =>
      v.name.toLowerCase().includes(input.toLowerCase())
    );
    setFilteredVendors(filtered);
    setShowVendorList(true);

    const existingVendor = vendors.find(
      (v) => v.name.toLowerCase() === input.toLowerCase()
    );

    if (existingVendor) {
      setAdvanceForm({ ...advanceForm, vendor_id: existingVendor.id });
    } else {
      setAdvanceForm({ ...advanceForm, vendor_id: "" });
    }
  };

  const handleVendorSelect = (vendor) => {
    setVendorName(vendor.name);
    setAdvanceForm({ ...advanceForm, vendor_id: vendor.id });
    setFilteredVendors([]);
    setShowVendorList(false);
    setHighlightedVendorIndex(-1);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              name="date"
              value={advanceForm.date}
              onChange={handleChange}
              disabled={false}
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3 position-relative">
            <Form.Label>
              Vendor<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={vendorName}
              onChange={handleVendorChange}
              onFocus={() => {
                if (filteredVendors.length > 0) setShowVendorList(true);
              }}
              onBlur={() => setTimeout(() => setShowVendorList(false), 150)}
              onKeyDown={(e) => {
                if (!showVendorList || filteredVendors.length === 0) return;

                if (e.key === "ArrowDown") {
                  e.preventDefault();
                  setHighlightedVendorIndex((prev) =>
                    prev < filteredVendors.length - 1 ? prev + 1 : 0
                  );
                } else if (e.key === "ArrowUp") {
                  e.preventDefault();
                  setHighlightedVendorIndex((prev) =>
                    prev > 0 ? prev - 1 : filteredVendors.length - 1
                  );
                } else if (e.key === "Enter") {
                  e.preventDefault();
                  if (highlightedVendorIndex >= 0) {
                    handleVendorSelect(filteredVendors[highlightedVendorIndex]);
                  }
                } else if (e.key === "Escape") {
                  setShowVendorList(false);
                }
              }}
              autoComplete="off"
              required
            />
            {showVendorList && vendorName && filteredVendors.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  zIndex: 10,
                  background: "white",
                  border: "1px solid #ccc",
                  width: "100%",
                  borderRadius: "5px",
                  maxHeight: "150px",
                  overflowY: "auto",
                }}
              >
                {filteredVendors.map((vendor, index) => (
                  <div
                    key={vendor.id}
                    onClick={() => handleVendorSelect(vendor)}
                    style={{
                      padding: "6px 10px",
                      cursor: "pointer",
                      borderBottom: "1px solid #eee",
                      backgroundColor:
                        index === highlightedVendorIndex
                          ? "#007bff22"
                          : "white",
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {vendor.name}
                  </div>
                ))}
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Amount<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              name="amount"
              value={advanceForm.amount}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Remarks<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="remarks"
              value={advanceForm.remarks}
              onChange={handleChange}
              required
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  const next = document.querySelector(
                    `input[name="type"][value="Normal"]`
                  );
                  if (next) next.focus();
                }
              }}
            />
          </Form.Group>
        </Col>
      </Row>

      {/* <Row>
      <Col md={6}>
       <Form.Group className="mb-3">
        <Form.Label>Status</Form.Label>
        <Form.Select
          name="status"
          value={advanceForm.status}
          onChange={handleChange}
          disabled={isEdit} 
        >
          <option value="Open">Open</option>
        </Form.Select>
      </Form.Group> 
      </Col>
     </Row> */}

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Type</Form.Label>
            <div className="status-radio-group">
              <Form.Check
                type="radio"
                label="Normal"
                name="type"
                value="Normal"
                checked={advanceForm.type === "Normal"}
                onChange={handleChange}
                inline
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    const next = document.querySelector(
                      'button[type="submit"]'
                    );
                    if (next) next.focus();
                  }
                }}
              />
              <Form.Check
                type="radio"
                label="Receipt"
                name="type"
                value="Receipt"
                checked={advanceForm.type === "Receipt"}
                onChange={handleChange}
                inline
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    const next = document.querySelector(
                      'button[type="submit"]'
                    );
                    if (next) next.focus();
                  }
                }}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>

      <div className="form-action-buttons">
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>

        <Button
          type="submit"
          variant="primary"
          style={{ outline: "none", border: "none" }}
        >
          {isEdit ? "Update" : "Submit"}
        </Button>
      </div>
    </Form>
  );
};

export default VendorAdvanceForm;
